export const downloadB64File = (entity: string, binary: string) => {
  let a = document.createElement('a');

  a.href = `data:application/xlsx;base64,${binary}`;

  a.download = `${entity}Report.xlsx`;
  a.click();
};
